export default __webpack_public_path__ + "static/media/capability.89b3796e.svg";